import { FormControlLabel, FormGroup, Typography } from "@mui/material";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

type Props = {
  checked: boolean;
  handleSwitchToggle?: any;
  label?: any;
  isDisabled?: boolean;
  stylesx?: any;
  name?: string;
};
const IOSSwitchOnOff = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 56,
  height: 22,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(32px)",
      color: "var(--white)",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--emerald)",
        opacity: 1,
        border: 0,
        "&:after, &:before": {
          color: "var(--white)",
          fontSize: "10px",
          position: "absolute",
          top: "6px",
        },

        "&:after": {
          content: "'ON'",
          paddingLeft: "5px",

          fontSize: "10px",
        },
        "&:before": {
          content: "''",
          right: "4px",

          fontSize: "10px",
        },
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 1,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "var(--medium_jade)",
      border: "6px solid var(--white)",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 18,
    height: 18,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "var(--dark_gunmetal)",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&:after, &:before": {
      color: "var(--white)",
      fontSize: "11px",
      position: "absolute",
      top: "6px",
    },
    "&:after": {
      content: "''",
      left: "4px",
      fontSize: "10px",
    },
    "&:before": {
      content: "'OFF'",
      right: "10px",
      fontSize: "10px",
    },
  },
}));

export const SwitchCustOnOff = (props: Props) => {
  const { checked, handleSwitchToggle, label, isDisabled, stylesx, name } =
    props;
  return (
    <FormGroup>
      <FormControlLabel
        sx={{ ...stylesx }}
        control={
          <IOSSwitchOnOff
            name={name}
            checked={checked}
            onChange={handleSwitchToggle}
            inputProps={{ "aria-label": "controlled" }}
            disabled={isDisabled || false}
            sx={{ m: 1 }}
          />
        }
        label={
          <Typography
            sx={{ fontSize: 14, fontFamily: "var(--switch_label_font_family)" }}
          >
            {label}
          </Typography>
        }
      />
    </FormGroup>
  );
};
